import { useCandidateMutation, type CandidateMutationParams } from './useCandidateMutation';
import { verificationActions } from './verificationActions';
import type { CreateVerificationRequest } from '@/features/verifications/types/verification.types';

export interface CandidateVerificationMutations {
  createVerification: (request: CreateVerificationRequest) => void;
  deleteVerification: (verificationId: string) => void;
  sendVerification: (verificationId: string) => void;
  isSending: boolean;
}

interface Params extends CandidateMutationParams {
  experienceId: string;
}

const MESSAGES = {
  create: { success: 'Reference contact added', error: 'Failed to add reference contact' },
  remove: { success: 'Reference contact removed', error: 'Failed to remove reference contact' },
  send: { success: 'Verification request sent', error: 'Failed to send verification request' },
};

// The experience status badge is derived from its verifications, so every verification
// mutation must also refresh the experiences list.
const EXPERIENCES_KEY = ['candidate-experiences'];

export function useCandidateVerificationMutations(params: Params): CandidateVerificationMutations {
  const { queryKey, isAnonymous, shareId, experienceId } = params;
  const actions = verificationActions(isAnonymous, shareId, experienceId);
  const createVerification = useCandidateMutation(
    queryKey,
    actions.create,
    MESSAGES.create,
    EXPERIENCES_KEY
  );
  const deleteVerification = useCandidateMutation(
    queryKey,
    actions.remove,
    MESSAGES.remove,
    EXPERIENCES_KEY
  );
  const sendVerification = useCandidateMutation(
    queryKey,
    actions.send,
    MESSAGES.send,
    EXPERIENCES_KEY
  );

  return {
    createVerification,
    deleteVerification,
    sendVerification,
    isSending: sendVerification.isPending,
  };
}
